import { cptCodeSignature } from 'client-portal/utils/clinicianSearch/service-facet-helpers/comparing-attributes';
import { preselectionIdsForQueryParam } from './booking-query-params';

function findRecordById(model, id) {
  let normalized = String(id ?? '').trim();
  if (!model?.length || !normalized) {
    return null;
  }

  return model.find(record => String(record?.id) === normalized) ?? null;
}

export function preselectedRecordFromModel(model, queryParams = {}, exactKey, candidateKey) {
  let exactId = String(queryParams?.[exactKey] ?? '').trim();
  if (exactId) {
    return findRecordById(model, exactId);
  }

  let candidateIds = preselectionIdsForQueryParam(queryParams, candidateKey);
  if (candidateIds.length === 1) {
    return findRecordById(model, candidateIds[0]);
  }

  if (queryParams?.preselected && model?.length === 1) {
    return model[0] ?? null;
  }

  return null;
}

export function preselectedCptCodeFromServicesModel(
  model,
  queryParams = {},
  exactKey,
  candidateKey
) {
  let found = preselectedRecordFromModel(model, queryParams, exactKey, candidateKey);
  if (found) {
    return found;
  }

  if (!queryParams?.preselected) {
    return null;
  }

  let candidateIds = new Set(preselectionIdsForQueryParam(queryParams, candidateKey));
  if (!candidateIds.size) {
    return null;
  }

  let rows = [...model];
  if (!rows.length) {
    return null;
  }

  if (!rows.every(cptCode => candidateIds.has(cptCode.id))) {
    return null;
  }

  let signatures = rows.map(cptCode => cptCodeSignature(cptCode));
  if (new Set(signatures).size !== 1) {
    return null;
  }

  return rows[0];
}
